export default __webpack_public_path__ + "static/media/checkmark.6c2ab360.svg";